import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent, Typography, Box } from '@mui/material';
import { formatCurrency, toTitleCase } from '../../../utils';
import { useContent } from '../../../logic'

interface CompletePayloadTaskDialogProps {
    open: boolean;
    setUserCompleteOpen: (open: boolean) => void;
    onUserCompleteTask: () => void;
    total: number
}

export function CompletePayloadTaskAmountRemainingAutoDialog({ open, setUserCompleteOpen, onUserCompleteTask, total }: CompletePayloadTaskDialogProps) {

  const { TaskText } = useContent()
  const totalFormatted = formatCurrency(total)

  return <Dialog key="userComplete" open={open} maxWidth="sm" fullWidth>
    <DialogTitle>Complete {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary">Total Submitted</Typography>
        <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'primary.main', mb: 2 }}>
          {totalFormatted}
        </Typography>
      </Box>
      <DialogContentText sx={{ mb: 1, textAlign: 'left' }}>Your submitted payments now total {totalFormatted}.</DialogContentText>
      <DialogContentText sx={{ textAlign: 'left' }}>Would you like to mark this {TaskText} as complete? You won't be able to make any more payments once it's completed.</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="rounded" onClick={() => setUserCompleteOpen(false)}>
        Not yet
      </Button>
      <Button variant="contained" onClick={onUserCompleteTask}>
        Yes, complete it
      </Button>
    </DialogActions>
  </Dialog>
}
